import * as React from 'react'
import Stack from '@mui/material/Stack'
import VendorRfpCardNew from 'vendors/vendorUserRequestForProposals/vendorRfpCards/VendorRfpCardNew'
import AvailableToEditProposalCard from 'vendors/vendorUserRequestForProposals/vendorRfpCards/AvailableToEditProposalCard'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  useVendorUsersReguestForProposalsAvailableToModify,
  useVendorUsersOpenRequestForProposals
} from 'vendors/queries/useVendorUserQuery'
import { CircularProgress } from '@mui/material'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const VendorUserOpenRfps: React.FC = () => {
  const { t } = useTranslation()
  const { data: openRfps = [], isLoading, isError } = useVendorUsersOpenRequestForProposals()
  const {
    data: availableToModifyProposals = [],
    isLoading: isLoadingAvailableToModify,
    isError: isErrorAvailableToModify
  } = useVendorUsersReguestForProposalsAvailableToModify()

  if (isError || isErrorAvailableToModify) {
    return <Navigate to="/error" />
  }

  if (openRfps.length === 0 && availableToModifyProposals.length === 0 && !isLoading && !isLoadingAvailableToModify) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1 }}>
        <img src={'/open_rfps_empty_state.png'} alt="no open request for proposals" />
        <Typography variant="h5" sx={{ fontWeight: 'fontWeightLight', mt: 5 }} gutterBottom>
          {t('no-open-request-for-proposals')}
        </Typography>
        <Typography sx={{ textAlign: 'center', maxWidth: '65ch', mb: 4 }} color="textSecondary">
          {t('no-open-rfps-helper-text')}
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {isLoading || isLoadingAvailableToModify ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          <Stack spacing={2}>
            {openRfps.map((rfp) => (
              <VendorRfpCardNew key={rfp.requestForProposalId} rfp={rfp} />
            ))}
          </Stack>
          <Stack spacing={2} sx={{ mt: 2 }}>
            {availableToModifyProposals.map((proposal) => (
              <AvailableToEditProposalCard key={proposal.requestForProposalId} proposal={proposal} />
            ))}
          </Stack>
        </>
      )}
    </>
  )
}

export default VendorUserOpenRfps
